import { Auth } from '@aws-amplify/auth';
import jwtDecode from "jwt-decode";
import CryptoJS from "crypto-js";

const SECRET12 = "YWNb!vdEW?82FJRJA*$EXB6cMU&BDe4EX-awwLpzNw2$d735h3"; // .env
const keyBitLength = 128; // .env
const iterations = 100; // .env
const LengthDiv = 32; //.env

export function encryptAES(plainText, password = SECRET12) {
  const salt = CryptoJS.lib.WordArray.random(keyBitLength / 8);
  const key = CryptoJS.PBKDF2(password, salt, {
    keySize: keyBitLength / LengthDiv,
    hasher: CryptoJS.algo.SHA1,
    iterations: iterations
  });
  const iv = CryptoJS.lib.WordArray.random(keyBitLength / 8);
  const encrypted = CryptoJS.AES.encrypt(plainText, key, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC
  });
  const encryptedMessage = [
    encrypted.ciphertext.toString(CryptoJS.enc.Base64),
    iv.toString(CryptoJS.enc.Hex),
    salt.toString(CryptoJS.enc.Hex)
  ].join("");
  return encryptedMessage;
}

export function decryptAES(password, encryptedMessage) {
  const salt = CryptoJS.enc.Hex.parse(
    encryptedMessage.substr(encryptedMessage.length - 32)
  );
  const iv = CryptoJS.enc.Hex.parse(
    encryptedMessage.substr(encryptedMessage.length - 64, 32)
  );
  const encrypted = encryptedMessage.substr(0, encryptedMessage.length - 64);

  const key = CryptoJS.PBKDF2(password, salt, {
    keySize: keyBitLength / LengthDiv,
    hasher: CryptoJS.algo.SHA1,
    iterations: iterations
  });

  const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC
  });

  const decryptedMessage = decrypted.toString(CryptoJS.enc.Utf8);

  if (!decryptedMessage) {
    throw new Error("Decrypt Error");
  }

  return decryptedMessage;
}

const hash256 = message => {
  const hash = CryptoJS.SHA256(message);
  return hash;
};

export function clearToken() {
  localStorage.removeItem("id_token");
}
export function setToken(token) {
  localStorage.setItem("id_token", token);
}
export function setIdClient(payload) {
  localStorage.setItem("id_client", payload.idClient);
}
export function getToken() {
  try {
    const idToken = localStorage.getItem("id_token");
    return idToken;
  } catch (err) {
    clearToken();
    return null;
  }
}
export function getIdClient() {
  try {
    const idClient = localStorage.getItem("id_client");
    return idClient;
  } catch (error) {
    return null;
  }
}
export async function getTokenSession() {
  try {
    let token = await Auth.currentSession();
    return token;
  } catch {
    return null;
  }
}
export function checkExpirity(token) {
  if (!token) {
    return {
      error: "not matched"
    };
  }
  try {
    const profile = jwtDecode(token);
    const expiredAt = profile.expiredAt || profile.exp * 1000;
    if (expiredAt > new Date().getTime()) {
      return {
        ...profile,
        token,
        expiredAt: new Date(expiredAt)
      };
    } else {
      return { error: "Token expired" };
    }
  } catch (e) {
    return { error: "Server Error" };
  }
}

export const decryptCredentials = value => {
  const rawData = Buffer.from(value, "base64").toString("hex");
  const ciphertext = CryptoJS.enc.Hex.parse(rawData);
  const pwhash = CryptoJS.SHA1(CryptoJS.enc.Utf8.parse(SECRET12));
  const key = CryptoJS.enc.Hex.parse(
    pwhash.toString(CryptoJS.enc.Hex).substr(0, 32)
  );
  const decryptBytes = CryptoJS.AES.decrypt(
    {
      ciphertext
    },
    key,
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }
  );
  const decryptMessage = decryptBytes.toString(CryptoJS.enc.Utf8);
  return decryptMessage;
};

export const MyStorage = {
  syncPromise: null,
  setItem: (key, value) => {
    const words = hash256(key);
    if (key && value) {
      sessionStorage.setItem(words, encryptAES(value, SECRET12));
      return sessionStorage.getItem(words);
    }
    return;
  },
  getItem: key => {
    const words = hash256(key);
    const value = sessionStorage.getItem(words);
    if (key && value) {
      const decryptMessage = decryptAES(SECRET12, value);
      return decryptMessage;
    }
    return;
  },
  removeItem: key => {
    const words = hash256(key);
    sessionStorage.removeItem(words);
  },
  clear: () => {
    sessionStorage.clear();
  }
};
